<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Italic')"
        :disabled="disabled || !editor.can().chain().focus().toggleItalic().run()"
        :class="{ 'is-active': editor.isActive('italic') }"
        @click="editor.chain().focus().toggleItalic().run()">
        <FormatItalicIcon size="16"/>
    </button>
</template>

<script>
import FormatItalicIcon from '@/common/components/svg-icons/FormatItalicIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarItalicButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatItalicIcon
    }
};
</script>
